import { IncorrectVoucherWithValidation } from './RemittancesSearchHistoryIncorrect.types';

export const IncorrectVoucherFieldNames = {
  REGIONAL_AGREEMENT_ID: 'regionalAgreementId' as keyof IncorrectVoucherWithValidation,
  WORKER_NISS: 'workerNiss' as keyof IncorrectVoucherWithValidation,
  ACTIVITY_TYPES: 'activityTypes' as keyof IncorrectVoucherWithValidation,
  SERVICE_DATE: 'serviceDate' as keyof IncorrectVoucherWithValidation,
  VOUCHER_IMAGE_URL: 'voucherImageUrl' as keyof IncorrectVoucherWithValidation,
};
